export default "<div class=\"pf-contest-card pf-contest-card--standard\"\n     layout=\"column\">\n</div>\n";